import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MernisQueryService} from "./services/mernis-query.service";
import {ValidatorService} from "../../services/validators/validator.service";

@Component({
  selector: 'app-mernis-query',
  templateUrl: './mernis-query.component.html',
  styleUrl: './mernis-query.component.scss'
})
export class MernisQueryComponent implements OnChanges {
  mernisForm: FormGroup;
  @Input() isQueryMade: boolean = false;
  @Input() isSuccess: boolean = false;
  @Output() queryResult = new EventEmitter<any>();
  @Input() formGroup: FormGroup; // Ana formdan gelen formGroup
  @Input() isFormInvalid: boolean = false; // Ana formdan gelen invalid durumu
  @Input() isSubmitTriggered: boolean = false;


  loading:boolean=false;
  isDisabled = false;
  errorMessage: string | null = null;
  isSubmit: boolean = false;

  constructor(private readonly fb: FormBuilder,
              private readonly  mernisQueryService: MernisQueryService,
              private readonly validatorService: ValidatorService
  ) {
    this.mernisForm = this.fb.group({
      idNumber: ['', [Validators.required,  Validators.pattern(/^\d*$/), this.validatorService.idNumberValidator()]],
      birthDate: ['', Validators.required],
    });

  }
  ngOnChanges(changes: SimpleChanges) {
    if (this.isSubmitTriggered) {
      this.isSubmit = true;
      this.mernisForm.markAllAsTouched();  // Formu tetikle ve validasyonları başlat
    }
  }

  updateValidations() {
    // Ana form invalid olduğunda inputları 'touched' yaparak mesajları gösterir
    if (this.isFormInvalid) {
      this.idNumber?.markAsTouched();
      this.birthDate?.markAsTouched();
    }
  }

  onInputChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value;

    if (/[^\d]/.test(value)) {
      inputElement.value = value.replaceAll(/[^\d]/g, '');
    }
  }

  get idNumber() {
    return this.mernisForm.get('idNumber');
  }

  get birthDate() {
    return this.mernisForm.get('birthDate');
  }

  onGetData(){
    console.log('kajasdkfljlsdkfj')
    return  this.mernisForm.value;
  }

  getButtonClass() {
    return {
      'text-success': this.isSuccess,
      'text-dark': !this.isQueryMade && !this.isSuccess,
      'text-secondary': this.isQueryMade && !this.isSuccess,
    };
  }
  onSubmit(event: Event) {
    this.isSubmit = true;
    event.preventDefault();

    if (this.isQueryMade) {
      return;
    }

    if (this.mernisForm.invalid) {
      return;
    }

    if (this.mernisForm.valid) {
      this.isQueryMade = true;
      const queryData = this.mernisForm.value;

      const birthDate = new Date(queryData.birthDate);
      const day = String(birthDate.getDate());
      const month = String(birthDate.getMonth() + 1);
      const year = String(birthDate.getFullYear());

      const requestData = {
        tckn: String(queryData.idNumber),
        birthDay: day,
        birthMonth: month,
        birthYear: year,
      };

      if (this.mernisForm.valid) {
        this.loading=true;
        this.mernisQueryService.getMernisUserData(requestData).subscribe({
          next: (res: any) => {
            this.queryResult.emit(res);
            this.isSuccess = res.isVerified;
            console.log('Gelen res:', res);
            this.loading=false;
            if (res.isVerified) {
              const { TCKimlikNo, Ad, Soyad, Cinsiyet } = res;
              console.log('Doğrulanan Kullanıcı Bilgileri:', {
                TCKimlikNo,
                Ad,
                Soyad,
                Cinsiyet,
              });

              this.mernisForm.patchValue({
                firstName: Ad,
                lastName: Soyad,
                gender: Cinsiyet,
              });
            } else {
              console.error('Doğrulama Hatası:', res.errorMessage);
            }
          },
          error:(error) => {
            this.loading=false;
          }
      });
      }
    }
  }
}
